module.exports = __webpack_public_path__ + "media/images/cl-logo-short-2bb32498.png";